import { IFetchCountriesQuery } from 'api/country';
import { downloadPlanFile, downloadPlanResultFile, useCountries, usePlanProgress, usePlanResults } from 'api/plan';
import { usePlanProgressCategoryRepresentation } from 'hooks/usePlanProgressCategoryRepresentation';
import { useEffect, useState } from 'react';

export function useNationalPlanningProcess() {
  const [currentCountryId, setCurrentCountryId] = useState<number>();
  const {
    data: planProgressData,
    isLoading: isPlanProgressListLoading,
    refetch: loadPlanProgressList,
  } = usePlanProgress({ countryId: currentCountryId }, { enabled: false });
  const {
    data: planResultsList,
    isLoading: isPlanResultsListLoading,
    refetch: loadPlanResultsList,
  } = usePlanResults({ countryId: currentCountryId }, { enabled: false });
  const { data: countries, isFetching: isCountriesLoading } = useCountries(
    {
      sorting: ['name:asc'],
      adminLevel: 0,
    } as IFetchCountriesQuery,
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    },
  );
  const planProgressList = usePlanProgressCategoryRepresentation(planProgressData?.data);
  const createHandleDownload = (id: number) => () => downloadPlanFile(id);
  const createHandleDownloadResult = (id: number) => () => downloadPlanResultFile(id);

  useEffect(() => {
    if (currentCountryId) {
      loadPlanProgressList();
      loadPlanResultsList();
    }
    // eslint-disable-next-line
  }, [currentCountryId]);
  useEffect(() => {
    if (countries) {
      setCurrentCountryId(countries[0].id);
    }
  }, [countries]);

  return {
    countries,
    isCountriesLoading,
    currentCountryId,
    setCurrentCountryId,
    planProgressList,
    isPlanProgressListLoading,
    planResultsList,
    isPlanResultsListLoading,
    createHandleDownload,
    createHandleDownloadResult,
  };
}
